// @ts-ignore Untyped module
import PublicAchievementContainer from './containers/Achievements/PublicAchievementContainer';
import { dataFetchingClient } from './utils/DataFetchingClient';
import { DataFetchingClientProvider } from 'academy-common-lib/utils/DataFetchingClient';
import { Route } from 'quartz-routing/react-router';
import { ThemeProvider } from 'academy-common-lib/utils/Styling';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const URL_LANG = /.*\/([a-z]{2})\/.*/;
export const getLocaleInfo = () => {
  const [, locale] = window.location.href.match(URL_LANG) || [null, 'en'];
  return {
    locale: locale || 'en',
    langEnabled: true
  };
};
export const prepareApp = () => {
  return {
    props: {}
  };
};
export function AppComponent() {
  return /*#__PURE__*/_jsx(ThemeProvider, {
    children: /*#__PURE__*/_jsxs(DataFetchingClientProvider, {
      client: dataFetchingClient,
      children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(Route, {
        component: PublicAchievementContainer,
        path: `/:publicId/:language/:template/:slug+`
      })]
    })
  });
}